import React from 'react';
import {
    MenuDivider, MenuGroup, MenuItem, SubMenu, MenuHeader,
} from '@szhsin/react-menu';
import { Icon } from 'semantic-ui-react';

interface AccessibleVerticalMenu {
    OptionList: Array<any>;
    className?: string;
}

const AccessibleVerticalMenu: React.FC<AccessibleVerticalMenu> = ({ OptionList, className }: AccessibleVerticalMenu) => {
    const filteredOptionsList = OptionList?.filter(({ option = {} }: any) => option !== null);
    const classes: string = className || '';
    return (
        <MenuGroup className={classes}>
            {
                filteredOptionsList?.map(({ optionProps = {}, content, subOptions }: any, index: number) => {
                    const {
                        hide, hasNoItemDivider, isMenuItemHeader, active, ...optProps // eslint-disable-line @typescript-eslint/no-unused-vars
                    } = optionProps;
                    if (Array.isArray(subOptions)) {
                        return (
                            <SubMenu key={`subMenu_${index}`} label={content}>
                                {
                                    subOptions.map(({
                                        onClick, content, value, active,
                                    }: any, subMenuItemIndex: number) => {
                                        return (
                                            <MenuItem
                                                onClick={onClick}
                                                key={`submenuItem_${subMenuItemIndex}`}
                                                value={value}
                                            >
                                                <div>
                                                    {content}
                                                </div>
                                                <div>
                                                    {active && <Icon name="checkmark" />}
                                                </div>
                                            </MenuItem>
                                        );
                                    })
                                }
                            </SubMenu>
                        );
                    }
                    return (
                        !hide && (
                            <React.Fragment key={`subMenu_${index}`}>
                                {isMenuItemHeader
                                    ? (
                                        <MenuHeader>
                                            {content}
                                        </MenuHeader>
                                    )
                                    : (
                                        <MenuItem {...optProps} key={index}>
                                            {content}
                                        </MenuItem>
                                    )}

                                {
                                    !hasNoItemDivider && <MenuDivider key={`divider_${index}`} />
                                }
                            </React.Fragment>
                        )
                    );
                })
            }
        </MenuGroup>
    );
};

export default AccessibleVerticalMenu;
